import { render, staticRenderFns } from "./zenga-range-input.vue?vue&type=template&id=6b53d51b&scoped=true&lang=pug"
import script from "./zenga-range-input.vue?vue&type=script&setup=true&lang=js"
export * from "./zenga-range-input.vue?vue&type=script&setup=true&lang=js"
import style0 from "./zenga-range-input.vue?vue&type=style&index=0&id=6b53d51b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b53d51b",
  null
  
)

export default component.exports